export interface BaseResponse {
  Id: string;
  IsSuccess: boolean;
  Message: string;
}

export class ServiceResponse<T> implements BaseResponse {
  constructor(val: T) {
    this.Id = "";
    this.IsSuccess = false;
    this.Message = "";
    this.Value = val;
  }
  Value: T;
  Id: string;
  IsSuccess: boolean;
  Message: string;
}

export class PageResponse<T> extends ServiceResponse<T> {
  PageNumber: number;
  PageSize: number;
  TotalCount: number;

  constructor(value: T, pageNumber: number, pageSize: number, totalCount: number) {
    super(value);
    this.PageNumber = pageNumber;
    this.PageSize = pageSize;
    this.TotalCount = totalCount;
  }
}
